import { Phone } from '@/modules/accredited-establishments/api/types'

const contactIcon = (type: string) =>
  type === 'WHATSAPP' ? 'icWhatsapp' : 'icPhone'

const formatNumber = (number: string) => number.replace(/[^\d]/g, '')

const labelPhone = (number: string) =>
  number.replace('(', '(0').replace(/\)/g, ') ')

const contactButtonName = (type: string) =>
  type === 'WHATSAPP' ? 'Contato WhatsApp' : 'Contato telefone'

const getHref = (phone: Phone) =>
  phone.type === 'WHATSAPP'
    ? `https://api.whatsapp.com/send?phone=${formatNumber(phone.number)}`
    : `tel:${formatNumber(phone.number)}`

export { contactButtonName, contactIcon, formatNumber, labelPhone, getHref }
